<template>
    <vue-slider
        ref="slider"
        tooltip="none"
        v-bind="$attrs"
        :disabled="disabled"
        :process-style="{
            position: 'absolute',
            height: '4px',
            backgroundColor: color,
            borderRadius: '4px',
            top: '0',
            bottom: '0',
            margin: 'auto',
        }"
        :dot-style="{
            cursor: disabled ? undefined : 'pointer',
            backgroundColor: color,
            borderRadius: '9999px',
            height: '12px',
            width: '12px',
        }"
        :label-style="{
            display: 'none',
        }"
        :height="6"
        :dot-size="[12, 12]"
        contained
        :class="[
            'input-slider  !py-0 my-1.5 bg-white border border-slate-200 rounded box-border',
            { 'one-dot': !isMultiInput },
        ]"
        @change="(value) => $emit('update:model-value', value)"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VueSlider from 'vue-slider-component';

/**
 * This is a wrapper component and build upon vue-slider.
 *
 * Read the official docs for available props and events here: https://nightcatsama.github.io/vue-slider-component
 */
export default defineComponent({
    name: 'InputSlider',
    components: {
        VueSlider,
    },
    inheritAttrs: false,
    props: {
        /**
         * Disables the input
         */
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:model-value'],
    computed: {
        color() {
            return this.disabled ? 'rgb(var(--colors-disabled))' : 'rgb(var(--colors-primary))';
        },
        isMultiInput() {
            return this.$attrs.modelValue instanceof Array;
        },
    },
    methods: {
        /**
         * sets value of the slider
         * @public
         */
        setValue(val: unknown) {
            // @ts-ignore cannot resolve ref
            this.$refs.slider.setValue(val);
        },
    },
});
</script>

<style lang="scss" scoped>
// because the slider dots should be contained inside the sliding box,
// the progress bar needs to be slightly adjusted to start from the beginning of the sliding box, which this CSS accomplishes
.input-slider.one-dot :deep(.vue-slider-process::before) {
    @apply absolute inset-0 rounded;
    background: inherit;
    content: '';
    margin-left: -5px;
    z-index: -1;
}
</style>
